module.exports = __webpack_public_path__ + "static/media/lakhdeepDP.14b0f710.jpg";